import React, { useEffect, useRef } from 'react';
import styles from './popover.module.css';
import Permission from '../Permission';

const Popover = ({
  actions,
  rowIndex,
  deleteType,
  itemId,
  handleActionPopover,
  status,
  setActions,
  popoverActions,
  setOpen,
  row,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (status === 'Ð½Ð¾Ð²Ð°Ñ') {
      setActions(popoverActions);
      ref.current.style.top = `-${ref.current.offsetHeight / actions.length + 75}px`;
    } else if (status === 'Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð°') {
      setActions(popoverActions.filter((item) => item.title !== 'ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ'));
      ref.current.style.top = `-${ref.current.offsetHeight / actions.length + 50}px`;
    } else if (status === 'Ð¾ÑÐ¼ÐµÐ½ÐµÐ½Ð°') {
      setActions(
        popoverActions.filter((item) => item.title !== 'ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ' && item.title !== 'Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ')
      );
      ref.current.style.top = `-${ref.current.offsetHeight / actions.length + 20}px`;
    } else if (status === 'ÑÑÐ¿ÐµÑÐ½Ð¾ Ð·Ð°Ð²ÐµÑÑÐµÐ½Ð°') {
      setActions(popoverActions.filter((item) => item.title === 'ÐÑÐ¾ÑÐ¼Ð¾ÑÑÐµÑÑ Ð·Ð°Ð¿Ð¸ÑÑ'));
      ref.current.style.top = `${0}px`;
    }
  }, []);

  return (
    <div className={styles.wrapper} ref={ref}>
      {actions.map((item, index) => (
        <Permission permission={item?.permission}>
          <div
            className={styles.row}
            key={index}
            onClick={() => {
              handleActionPopover && handleActionPopover(rowIndex, index, item.title, itemId, deleteType);
              item?.onClick && item?.onClick(row);
              setOpen(false);
            }}
          >
            <div>
              <img src={item.icon} alt="Icon" />
            </div>
            <div>
              <p>{item.title}</p>
            </div>
          </div>
        </Permission>
      ))}
    </div>
  );
};

export default Popover;
